// extracted by mini-css-extract-plugin
export default {"iconWrapper":"PasswordEmailSent_iconWrapper__bu-TW","resendMessage":"PasswordEmailSent_resendMessage__cFDOl"};